import project from "@utility@::/data/project.data";
import translations from "@utility@::/data/translations/index.translation";
import other from "@utility@::/data/other.data";

const List = { project, other, translations };

export default List;
